import React from 'react'
import {useAuth} from '../../modules/auth'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_metronic/helpers'

export function MenuInner() {
  const {business} = useAuth()
  return (
    <h1 className='page-heading d-flex text-dark fw-bold fs-3 my-0 flex-column justify-content-center'>
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {/* begin::Logo */}
        <Link to='/'>
          <img
            alt='Logo'
            className='h-50px logo'
            src={
              business?.BUSINESS_LOGO
                ? process.env.REACT_APP_BUCKET_URL + '/' + business.BUSINESS_LOGO
                : toAbsoluteUrl('/media/logos/default1.png')
            }
          />
        </Link>
        {/* end::Logo */}
      </div>
    </h1>
  )
}
